import React from 'react';
import { normalizeCartLineAddOns } from '../pages/OurMenu/cartAddOnUtils';
import './CartLineAddOns.css';

/**
 * Add-on breakdown under a cart / checkout host line.
 * `className` is appended as modifiers; BEM children always use `cart-line-addons__*`.
 * @param {{
 *   addOns?: Array<{ id?: number; name: string; price: number; quantity?: number }>,
 *   className?: string,
 *   showHeading?: boolean,
 * }} props
 */
export default function CartLineAddOns({
  addOns,
  className = '',
  showHeading = true,
}) {
  const rows = normalizeCartLineAddOns(addOns);
  if (!rows.length) return null;

  const rootClass = ['cart-line-addons', className].filter(Boolean).join(' ');

  return (
    <div className={rootClass}>
      {showHeading ? (
        <span className="cart-line-addons__heading">Add-ons</span>
      ) : null}
      <ul className="cart-line-addons__list">
        {rows.map((addon) => {
          const qty = Math.max(1, Number(addon.quantity) || 1);
          const unit = Number(addon.price || 0);
          const lineTotal = unit * qty;
          return (
            <li key={addon.id ?? addon.name} className="cart-line-addons__item">
              <span className="cart-line-addons__label">
                <span className="cart-line-addons__qty">{qty}×</span>
                <span className="cart-line-addons__name">{addon.name}</span>
              </span>
              <span className="cart-line-addons__amount">
                <span className="cart-line-addons__total">₹{lineTotal.toFixed(2)}</span>
                {qty > 1 ? (
                  <span className="cart-line-addons__unit">₹{unit.toFixed(2)} each</span>
                ) : null}
              </span>
            </li>
          );
        })}
      </ul>
    </div>
  );
}
